<template>
  <div class="common-footer">
    <el-divider></el-divider>
    <span>©2023 windsong</span>
    <span>仅供个人学习使用，切勿用作其他用途</span>
  </div>
</template>

<script>
export default {
  name: "CommonFooter"
}
</script>

<style lang="less" scoped>
  .common-footer {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 10px;
  }

  // 分割线
  .el-divider--horizontal {
    margin: 0;
  }
</style>
